import logoImage from '../assets/images/logo.png'
const Logo = ()=>{
    return(
        <div className="logo">
            <img src={logoImage} alt="" />
        </div>
    )
}
export default Logo